import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Twitter(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31 25"
  }, props), React.createElement("path", {
    d: "M27.675 7.05c0-.274 0-.547-.019-.818A12.861 12.861 0 0030.81 2.96a12.617 12.617 0 01-3.63.995A6.343 6.343 0 0029.957.458a12.668 12.668 0 01-4.014 1.535 6.327 6.327 0 00-10.772 5.765A17.946 17.946 0 012.144 1.153a6.326 6.326 0 001.957 8.439A6.274 6.274 0 011.232 8.8v.08a6.323 6.323 0 005.072 6.196 6.317 6.317 0 01-2.855.109 6.328 6.328 0 005.906 4.39A12.684 12.684 0 010 22.195a17.896 17.896 0 009.69 2.834c11.626.005 17.985-9.628 17.985-17.98z"
  }));
}

export { Twitter };
//# sourceMappingURL=Twitter.js.map